/* eslint-disable no-unused-expressions */
// import Head from "next/head";
// import icon from "@PUBLIC/favicon/ico_yb.ico";
import type {AppProps} from "next/app";
import {Provider} from "react-redux";
import store, {persistor} from "@/store";
import SEOWrapper from "@COMPONENTS/provider/SEOProvider";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import Container from "@COMPONENTS/layout";
import {PersistGate} from "redux-persist/integration/react";
import {QueryClientProvider, QueryClient, keepPreviousData} from "@tanstack/react-query";
import ErrPageDesktop from "@COMPONENTS/common/error/global/Desktop";
import ErrPageMobile from "@COMPONENTS/common/error/global/Mobile";
import AppProvider from "@COMPONENTS/provider";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

/** polyfill option */
// import "core-js/actual";
// import "core-js/stable";
import "core-js/es";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: true,
			refetchIntervalInBackground: false,
			gcTime: 1000 * 60 * 5,
			staleTime: 1000 * 60 * 5,
			enabled: true,
			placeholderData: keepPreviousData,
			// 5xx 만 ErrorBoundary 로 throw. 401/4xx 등은 호출부에서 data 가드로 처리하여 로그 노이즈 감소
			throwOnError: (error: any) => {
				const status = error?.response?.status ?? error?.status ?? 0;
				return status >= 500;
			},
			retry: false,
		},
	},
});

function MyApp({Component, pageProps, router}: AppProps) {
	return (
		<>
			<Provider store={store}>
				<SEOWrapper {...pageProps} />
				<PersistGate persistor={persistor}>
					<QueryClientProvider client={queryClient}>
						<AppProvider>
							<Container>
								<ErrorBoundary
									logMsg="_app"
									FallbackComponent={<>{router.pathname.includes(".m") ? <ErrPageMobile /> : <ErrPageDesktop />}</>}
								>
									<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
									<Component {...pageProps} />
								</ErrorBoundary>
							</Container>
						</AppProvider>
					</QueryClientProvider>
				</PersistGate>
			</Provider>
		</>
	);
}
export default MyApp;

// export async function getServerSideProps({ctx}) {
// 	let userAgent = "";

// 	if (ctx.req) {
// 		userAgent = ctx.req.headers["user-agent"] || "";
// 	} else {
// 		userAgent = navigator.userAgent;
// 	}

// 	return {pageProps: {userAgent}};
// }
